/*
 * @Author: 陈梦男
 * @Date: 2024-05-22 14:44:21
 * @LastEditTime: 2024-05-28 15:15:57
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 全球矿业市场政策库数据管理表头配置
 * @FilePath: \web\src\components\PolicyManager\tableConfig.js
 */
const tableConfigInformation = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '资讯名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '资讯地址',
    dataIndex: 'linkUrl',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '资讯内容',
    dataIndex: 'content',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '国内国际',
    dataIndex: 'type',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '来源',
    dataIndex: 'source',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '图片',
    dataIndex: 'img',
    slots: { customRender: 'img' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '资讯时间',
    dataIndex: 'date',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigCountry = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '国家类别',
    dataIndex: 'continent',
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '国家',
    dataIndex: 'countryName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '国旗',
    dataIndex: 'nationalFlag',
    slots: { customRender: 'nationalFlag' },
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '国别指南',
    dataIndex: 'guideFileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '税收指南',
    dataIndex: 'investFileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigMining = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '舆情时间',
    dataIndex: 'issueDate',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '文件',
    dataIndex: 'fileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigRegulationBak = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '来源',
    dataIndex: 'title',
    slots: {
      customRender: 'title',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '地址',
    dataIndex: 'linkUrl',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '图片',
    dataIndex: 'imgOverview',
    slots: {
      customRender: 'imgOverview',
    },
    ellipsis: true,
    align: 'center',
    // width: 100,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigRegulation = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
 {
    title: '国家类别',
    dataIndex: 'continent',
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '国家',
    dataIndex: 'countryName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '国旗',
    dataIndex: 'nationalFlag',
    slots: { customRender: 'nationalFlag' },
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '政策法规',
    dataIndex: 'guideFileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];
const tableConfigTaxation = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '报告名称',
    dataIndex: 'name',
    slots: {
      customRender: 'name',
    },
    ellipsis: true,
    align: 'center',
    width: 200,
  },
  {
    title: '作者/机构',
    dataIndex: 'owner',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '文件',
    dataIndex: 'fileName',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '报告日期',
    dataIndex: 'reportDate',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },

  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 180,
  },
];

export { tableConfigInformation, tableConfigCountry, tableConfigMining, tableConfigRegulation, tableConfigTaxation };
